import { useSession } from 'next-auth/react'

export function useIsLoggedIn(): boolean {
  return useSession()?.status === 'authenticated'
}
